import { useQuery } from "@tanstack/react-query";
import { cacheOptions, fetchFirebaseData } from "../../../../connector/functions";

export const useFirebaseProjectsHooks = (l: string) => {
    const stats = useQuery({
        queryKey: ['projects', l],
        queryFn: () => fetchFirebaseData(`site/shared/projects`),
        ...cacheOptions,
    });

    const content = useQuery({
        queryKey: ['projectContent', l],
        queryFn: () => fetchFirebaseData(`site/${l}/projects`),
        ...cacheOptions,
    });

    const projects = Object.assign({ 
        categories: new Set(["all", ...Object.values(stats.data ?? {}).map((project: any) => project.category)]),
        content: (stats.data && content.data) && Object.assign({}, ...Object.values(stats.data ?? {}).map((project: any) => {
            return {
                [project.id]: {
                    ...project,
                    ...content.data[project.id],
                },
            }
        })),
    });

    console.log(projects);

    return { projects };
};